import axios from "axios";
import qs from "qs";
import React from "react";
import Scroll from "react-scroll";
import SVG from "react-inlinesvg";
import { connect } from "react-redux";
import "../css/SavingScreen.scss";

const scroll = Scroll.animateScroll;

class SavingScreen extends React.Component {
	state = {
		showSavingMessage: false,
		programPath: "/" + window.appPath + "/program/"
	};

	componentDidMount() {
		scroll.scrollTo(0, { smooth: "easeInOut" });
	}

	handleAnimationEnd = () => {
		this.setState(
			{
				showSavingMessage: true
			},
			() => {
				const rows = document.querySelectorAll(".progress-row");
				let rowCount = 0;

				setTimeout(() => {
					for (let i = 0; i < rows.length; i++) {
						rows[0].querySelector(".saving-circle").classList.add("show");
						setTimeout(() => {
							// If last row, save report and don't animate last row
							if (i + 1 === rows.length) {
								this.handleReportSave();
							} else {
								rows[i].classList.add("active");
								rows[i + 1]
									.querySelector(".saving-circle")
									.classList.add("show");
							}
						}, 2000 * rowCount++);
					}
				}, 500); // Wait for rows to animate
			}
		);
	};

	handleReportSave() {
		const data = {
			// action: "save_loyalty_report",
			report_data: {
				name: this.props.name,
				industry: this.props.industry,
				palette: this.props.palette,
				goals: this.props.goals,
				orders: this.props.orders,
				rewards: this.props.rewards
			}
		};

		axios
			.post(window.localize_script.warehouse_api_url + 'loyalty-program-generator/create', qs.stringify(data))
			.then(response => {
				if (response.data.status === "success") {
					document
						.querySelector(".generating-report-row")
						.classList.add("active");
					window.location = this.state.programPath + response.data.report_id;
				}
			})
			.catch(function (error) {
				console.log(error);
				alert("Error! Please refresh the page and try again.");
			});
	}

	render() {
		return (
			<div className="saving-screen" onAnimationEnd={this.handleAnimationEnd}>
				<div className="saving-screen-content">
					<h1 className={this.state.showSavingMessage ? "active" : ""}>
						Your CUSTOM loyalty & referrals program <span>is on its way…</span>
					</h1>

					<div
						className={
							"rows " + (this.state.showSavingMessage ? "active" : "")
						}>
						<div className="progress-row">
							<div className="progress-icon">
								<SVG
									className="saving-circle"
									src="./images/loading-circle.svg"
								/>
								<SVG className="checkmark" src="./images/checkmark.svg" />
							</div>
							<div className="progress-title">Calculating Rewards</div>
						</div>
						<div className="progress-row">
							<div className="progress-icon">
								<SVG
									className="saving-circle"
									src="./images/loading-circle.svg"
								/>
								<SVG className="checkmark" src="./images/checkmark.svg" />
							</div>
							<div className="progress-title">Defining Program Goals</div>
						</div>
						<div className="progress-row generating-report-row">
							<div className="progress-icon">
								<SVG
									className="saving-circle"
									src="./images/loading-circle.svg"
								/>
								<SVG className="checkmark" src="./images/checkmark.svg" />
							</div>
							<div className="progress-title">Generating Loyalty Program</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		name: state.name,
		industry: state.industry,
		palette: state.palette,
		goals: state.goals,
		orders: state.orders,
		rewards: state.rewards
	};
};

export default connect(mapStateToProps)(SavingScreen);
